/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  vertical-align: middle;
}
:host .flexbox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
}
:host .flexbox svg {
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  fill: #EA0823;
  fill: var(--davinci-color-error, #EA0823);
}
:host .flexbox .icon {
  flex: 0 1 auto;
  fill: #737F85;
  fill: var(--davinci-color-text-lighter, #737F85);
}
:host .flexbox .label {
  flex: 0 1 auto;
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .flexbox.hasContent .label {
  padding-left: 0.5714285714rem;
}

:host([status=true]) .flexbox svg {
  fill: #63b017;
  fill: var(--davinci-color-success, #63b017);
}

:host([disabled]) svg,
:host([disabled]) .icon {
  fill: var(--davinci-color-outline-disabled,) !important;
}
:host([disabled]) .label {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .label slot ::slotted(*) {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
